import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import type { PartnerName } from '../../../../definitions';
import type { PriceOfferQuoteQueryParams } from '../../queries';
import { BrandPriceComparison } from './BrandPriceComparison';
import { BrandAnimationLayout } from './styles';

export const Brand: FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const priceOfferId = searchParams.get('priceOfferId');
  const priceOfferApiVersion = searchParams.get('apiVersion');
  const addons = searchParams.getAll('addons');
  const partnerName = searchParams.get('partnerName')?.toLowerCase() as PartnerName | null;
  const utmParams = Object.fromEntries(Array.from(searchParams.entries()).filter(([key]) => key.startsWith('utm_')));

  return (
    <BrandAnimationLayout>
      {priceOfferId != null && (
        <BrandPriceComparison
          addons={addons as PriceOfferQuoteQueryParams['addons']}
          partnerName={partnerName}
          priceOfferApiVersion={priceOfferApiVersion}
          priceOfferId={priceOfferId}
          utmParams={utmParams}
        />
      )}
    </BrandAnimationLayout>
  );
};
